import React from 'react';
import { useForm } from "react-hook-form";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { useRef } from 'react'
import './Contact.css';

function Contact() {
    const { setValue } = useForm();
    const [result, setResult] = React.useState("");
    const [captchaToken, setCaptchaToken] = React.useState("");
    const [setError] = React.useState("");
    const captchaRef = useRef(null);

    const onHCaptchaChange = (token) => {
        setCaptchaToken(token);
        setValue("h-captcha-response", token);
        setError("");
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        // setResult("Sending...");

        if (!captchaToken) {
            alert("Please complete the captcha.");
            setResult(""); // clear the "Sending..." message
            return;
        }

        const formData = new FormData(event.target);
        formData.append("access_key", "a40e5179-ba9c-494e-96d0-30941c4dcecf");

        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: json
        });

        const result = await response.json();

        if (result.success) {
            console.log("Success", result);
            // setResult("Form Submitted Successfully");
            event.target.reset();
            setResult("");

            if (captchaRef.current) {
                captchaRef.current.resetCaptcha();
            }
        } else {
            console.log("Error", result);
            setResult(result.message);
        }
    };

    return (
        <React.Fragment>
            <div className='container my-5'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='contact-title'>
                            <h1> Inquiries </h1>
                            <p className='contact-text'> Send the team at CMO an inquiry by completing the form below. We will get back to you as soon as we can. </p>
                        </div>

                        <div className='contact-form'>
                            <form onSubmit={onSubmit}>
                                <input type="hidden" name="from_name" value="CMO Website Contact Form Submission" />

                                <div className="form-group">
                                    <label htmlFor="name"> Name * </label>
                                    <input type="text" id="name" name="name" placeholder="Your Name" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email"> Email * </label>
                                    <input type="email" id="email" name="email" placeholder="Your Email" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone"> Phone Number </label>
                                    <input type="tel" id="phone" name="phone" placeholder="Your Phone Number (optional)" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message-subject"> Message Subject * </label>
                                    <input type="text" id="message-subject" name="message-subject" placeholder="Subject" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message"> Message * </label>
                                    <textarea id="message" name="message" placeholder="Your Message" rows="5" required></textarea>
                                </div>
                                <div className='form-group'>
                                    <button type="submit" className="btn btn-primary"> Submit </button>
                                </div>

                                <HCaptcha sitekey="50b2fe65-b00b-4b9e-ad62-3ba471098be2" reCaptchaCompat={false}
                                    onVerify={onHCaptchaChange} ref={captchaRef} />
                            </form>
                            <span> {result} </span>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div className='contact-info'>
                            <div className='contact-method'>
                                <h5> Phone Number </h5>
                                <p> <a href='tel: +1 (604) 831 9276'> +1 (604) 831-9276 </a> </p>
                            </div>

                            <div className='contact-method'>
                                <h5> Email </h5>
                                <p> <a href='mailto: info@cmoconsultants.ca'> info@cmoconsultants.ca </a> </p>
                            </div>

                            <div className='contact-method'>
                                <h5> Address </h5>
                                <p> 300 - 1 West 7th Avenue <br />
                                    Vancouver, BC  V5Y 1L4 </p>
                                <div className="map-container">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d937.6869805037065!2d-123.10546671349753!3d49.264909815338285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548673e0718dc5ad%3A0x7dd0275df343b7e1!2s1%20W%207th%20Ave%2C%20Vancouver%2C%20BC%20V5Y%201L4!5e0!3m2!1sen!2sca!4v1754455265670!5m2!1sen!2sca"
                                        title='CMO Consultants Location'
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Contact;